export default __webpack_public_path__ + "static/media/img3.9b1e7d17.png";